import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import {getEmailTemplates, GetInterfaceLang} from '../../actions/index';

class emailTemplates extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.renderTable = this.renderTable.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.getEmailTemplates(token);
        this.props.GetInterfaceLang(token);
    }
    editEmail(id, item){
        this.context.router.push('/email_template/edit/'+id);
    }
    renderIcon(item){
        let that = this;
        return item.map((code)=>{
            return that.props.lang.interface_lang.results.map((lang) => {
                if(lang.id == code){
                    return <i>{lang.lang.code}</i>
                }
            });
        });
    }
    renderTable(){
        return this.props.email.email_temp.map((item, i)=>{
            return(
                <div key={item.type} id={item.type} className="white-block common-list two clearfix">
                    <p>{i+1}</p>
                    <p className="common-item-with-tag">
                        <span className="link-span" onClick={this.editEmail.bind(this, item.type)}>{item.name}</span>
                        {this.props.lang.interface_lang && this.props.lang.interface_lang.results && this.props.lang.interface_lang.results.length>0 ? this.renderIcon(item.blangs) : ""}
                    </p>
                    <p>
                        <button type="button" onClick={this.editEmail.bind(this, item.type)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true" />
                        </button>
                    </p>
                </div>
            )
        })
    }
    render() {
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-title clearfix"><p className="pull-left">Email templates</p></div>
                {this.props.email.email_temp && this.props.email.email_temp.length > 0 ?
                    <div>
                        <div className="col-md-12">
                            <div className="common-list two clearfix">
                                <p>#</p>
                                <p>Name</p>
                                <p>Option</p>
                            </div>
                        </div>
                        <div className="col-md-12">
                            {this.renderTable() }
                        </div>
                    </div>
                    :
                    <div className={this.props.email.email_temp && this.props.email.email_temp.length < 0 || $.isEmptyObject(this.props.email.email_temp) ? "for_preloader" : 'for_preloader dn'}>
                        <div className="preloader-wrapper big active">
                            <div className="spinner-layer spinner-blue-only">
                                <div className="circle-clipper left">
                                    <div className="circle" />
                                </div>
                                <div className="gap-patch">
                                    <div className="circle" />
                                </div>
                                <div className="circle-clipper right">
                                    <div className="circle" />
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {this.props.email.email_temp && this.props.email.email_temp.length === 0 && <p className="noResults">No items result</p>}
                <div className="clearfix"></div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        email: state.email,
        lang: state.lang
    }
}
export default connect(mapStateToProps, {getEmailTemplates, GetInterfaceLang})(emailTemplates);


// WEBPACK FOOTER //
// ./src/components/email_template/list.js